<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family:"Microsoft YaHei", "Arial-Regular", "Helvetica Neue", Helvetica, STHeiTi, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.top{
  position: relative;
  width:100%;
}
.m_top{
  width: 100vw;
  height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.m_top img{
  height: 100vw;
}
.posa_txt{
  position: absolute;
  top: 45%;
  width: 100%;
  font-size: 72px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  letter-spacing:5px;
  -webkit-text-stroke-width: 1px;
  text-stroke-width: 1px;
  text-stroke-color: #ccc;
  text-shadow:2px 2px 5px #333;
}
.posa_txt.mobile{
  font-size: 32px;
  letter-spacing:1.5px;
  font-weight: normal;
}
.location_box{
  border-bottom: 1px solid #ddd;
}
.location_box .nav_item{
  display: block;
  height: 65px;
  line-height: 65px;
  border-right: 1px solid #ddd;
  padding: 0 30px;
  box-sizing: border-box;
  text-align: center;
  font-size: 16px;
  color: #222;
}
.location_box .nav_item.curr{
  background-color:#1C4383 ;
  color: #fff;
}

.lan_show_box_m{
  position: absolute;
  top: 35px;
  right:5px;
  width: 130px;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #efefef;
  box-shadow: 1px 2px 3px #efefef;
  z-index: 999;
}
.lan_show_box_m:after{
  content: "";
  display: block;
  position: absolute;
  top: -29px;
  left: 50%;
  width: 0;
  height: 0;
  border:15px solid;
  border-color: transparent transparent #fff;
}
.lan_show_box_m:before{
  content: "";
  display: block;
  position: absolute;
  top: -30px;
  left: 50%;
  width: 0;
  height: 0;
  border:15px solid;
  border-color: transparent transparent #efefef;
}

.lan_show_box_m a{
  display: block;
  height: 35px;
  color: #666;
  line-height: 35px;
  text-align: center;
  border-bottom: 1px solid #efefef;
}
.lan_show_box_m a.curr{
  color: #0056BD;
}
.lan_show_box_m a:last-child{
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue